<template>      
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>            
              Compopo | קומפופו            
          </li>
          <li>
            <a href="/qna" target="_blank">
              Q & A
            </a>
          </li>
          <li>
            <a href="/termsofuse" target="_blank">
              Terms of Use
            </a>
          </li>                    
          <li>
            <a href="https://www.freeprivacypolicy.com/live/ee56ac73-98b3-4233-b5b1-d6cbcd35f80f" target="_blank">
              Privacy Policy
            </a>
          </li>
          <li>
            <a href="https://www.termsfeed.com/live/b42b2cf2-4847-4b76-8130-f24edb695618" target="_blank">
              Cookie Policy
            </a>
          </li>                    
          <li>
            <a href="">
              About Us
            </a>
          </li> 
                 
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Designed by
        <a href="" 
          >Compopo</a
        >
      </div>
    </div>
  </footer>  
</template>
<script>
export default { 
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {      
      year: new Date().getFullYear()
    };
  }
};
</script>


